import { Close, Save } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  IconButton,
  TextField,
  Typography,
  Skeleton,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import { useState, useEffect } from "react";
import theme from "../../theme/theme";

export const EditAttendanceDialog = ({
  open,
  onClose,
  attendance,
  onUpdate,
  loading,
}) => {
  const [formData, setFormData] = useState({
    time_in: null,
    time_out: null,
    notes: "",
  });

  useEffect(() => {
    if (attendance) {
      setFormData({
        time_in: attendance.time_in ? dayjs(attendance.time_in) : null,
        time_out: attendance.time_out ? dayjs(attendance.time_out) : null,
        notes: attendance.notes || "",
      });
    }
  }, [attendance]);

  const handleSubmit = () => {
    const payload = {
      ...formData,
      time_in: formData.time_in
        ? formData.time_in.format("YYYY-MM-DD HH:mm:ss")
        : null,
      time_out: formData.time_out
        ? formData.time_out.format("YYYY-MM-DD HH:mm:ss")
        : null,
    };
    onUpdate(attendance.id, payload);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: theme.dialog.borderRadius,
          minWidth: theme.dialog.minWidth,
          maxWidth: "sm",
          width: "100%",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.dialog.headerBgColor,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          fontWeight={"bold"}
          color={theme.palette.primary.main}
        >
          Edit Attendance
        </Typography>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Box>

      <Box sx={{ p: 4, display: "flex", flexDirection: "column", gap: 3 }}>
        {!attendance ? (
          <>
            <Skeleton variant="rounded" height={56} />
            <Skeleton variant="rounded" height={56} />
            <Skeleton variant="rounded" height={56} />
          </>
        ) : (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="Check In Time"
              value={formData.time_in}
              onChange={(newValue) =>
                setFormData({ ...formData, time_in: newValue })
              }
              slotProps={{ textField: { fullWidth: true } }}
            />
            <DateTimePicker
              label="Check Out Time"
              value={formData.time_out}
              onChange={(newValue) =>
                setFormData({ ...formData, time_out: newValue })
              }
              slotProps={{ textField: { fullWidth: true } }}
            />
            <TextField
              label="Notes"
              multiline
              rows={3}
              fullWidth
              value={formData.notes}
              onChange={(e) =>
                setFormData({ ...formData, notes: e.target.value })
              }
            />
          </LocalizationProvider>
        )}
      </Box>

      <Box
        sx={{
          backgroundColor: theme.dialog.headerBgColor,
          p: 2,
          display: "flex",
          justifyContent: "end",
          gap: 2,
        }}
      >
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: theme.button.backgroundColor,
            color: "#000",
            borderRadius: theme.button.borderRadius,
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
          startIcon={<Save />}
          sx={{
            backgroundColor: theme.button.editBackgroundColor,
            borderRadius: theme.button.borderRadius,
          }}
        >
          {loading ? "Updating..." : "Update"}
        </Button>
      </Box>
    </Dialog>
  );
};
